import actionType from "../constents/action.type";

const initialState = {
  categories: [],
  userData: {
    info: null,
    permissions: [],
  },
};

const datasStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.GET_CATEGORIES:
      return Object.assign({}, state, { categories: action.payload.categories });

    case actionType.SET_USER_DATA:
      let userData = action.payload.data;
      console.log("User Data:", userData);  

      // Ensure userData is valid and permissions is an array
      if (userData) {
        // Ensure permissions is an array
        userData.permissions = Array.isArray(userData.permissions)
          ? Object.values(userData.permissions)
          : [];

        // Ensure info is not null and has super_admin property
        if (userData.info && userData.info.super_admin === 1) {
          userData.permissions.push("user_super_admin");
        }
      } else {
        // If userData is undefined, we ensure permissions is an empty array
        userData = {
          info: null,
          permissions: [],
        };
      }

      return Object.assign({}, state, { userData: userData });

    default:
      return state;
  }
};

export default datasStore;
